import * as fabric from 'office-ui-fabric-react';
import React, { FC } from 'react';
import * as api from '../../../api/generated';
import { logout, useAuthentication } from '../../../components';
import { ILocationItem } from '../../../components/custom/LocationTree';
import { locationType } from '../../../enums';
import { activeLocationStateCircle, inActiveLocationStateCircle, titleStyles } from '../Helpers';

const closeIcon: fabric.IIconProps = {
    iconName: 'Contact',
    styles: {
        root: {
            color: 'white',
            paddingTop: '5px',
            fontSize: '25px'
        }
    }
};

interface IQueueManagementHeaderProps {
    locationId: number | null;
    setLocationId: Function;
    locations: ILocationItem[] | null;
}

const QueueManagementHeader: FC<IQueueManagementHeaderProps> = (props: IQueueManagementHeaderProps) => {
    const { username, assembly } = useAuthentication();

    const getFullLocationName = (allLocations: ILocationItem[]) => {
        const selectedLocation = allLocations.find(x => x.id === props.locationId);
        let locationName = selectedLocation?.name;
        if (selectedLocation?.locationType === locationType.Cabinet) {
            locationName += ' -> ' + allLocations.find(x => x.id === selectedLocation?.partOfLocationId)?.name;
        }
        return locationName;
    };

    return (
        <fabric.Stack id={'titleContainer'} horizontal verticalAlign="center" styles={titleStyles}>
            <fabric.Stack>
                <fabric.Text variant={'xLarge'} style={{ padding: 10 }}>
                    Eilių valdymas <fabric.Text variant="medium">{assembly}</fabric.Text>
                </fabric.Text>
            </fabric.Stack>

            <fabric.Stack horizontalAlign="end" className="locationSelection" style={{ marginLeft: 'auto' }}>
                {props.locationId && props.locations && (
                    <span>
                        <fabric.ActionButton
                            label="Keisti darbo vietą"
                            iconProps={closeIcon}
                            style={{ color: 'white' }}
                            onClick={async () => {
                                props.setLocationId(null);
                                localStorage.removeItem('locationId');
                                await api.queueManagement.removeSelections(props.locationId!);
                            }}
                        />
                        <fabric.Icon
                            iconName="FullCircleMask"
                            styles={activeLocationStateCircle}
                            title={`Darbo vieta: ${getFullLocationName(props.locations)}`}
                        />
                    </span>
                )}
                {!props.locationId && (
                    <span>
                        <fabric.Icon iconName="FullCircleMask" styles={inActiveLocationStateCircle} title={`Darbo vieta nepasirinkta`} />
                    </span>
                )}
            </fabric.Stack>
            <fabric.Stack horizontalAlign="end" style={{ flexDirection: 'row', color: 'white' }}>
                <fabric.Text style={{ marginRight: '10px' }}>{username}</fabric.Text>
                <fabric.Link
                    variant={'xxLarge'}
                    style={{ border: 'none' }}
                    onClick={async () => {
                        localStorage.removeItem('locationId');
                        await logout();
                    }}
                >
                    <fabric.Text style={{ color: 'white' }}>Atsijungti</fabric.Text>
                </fabric.Link>
            </fabric.Stack>
        </fabric.Stack>
    );
};

export default QueueManagementHeader;
